import { isCustomerNumber, required as hasValue } from "../../validations/validations";
import classNames from "classnames";
import React, { useMemo } from "react";
import Input from "../Input/Input";

import Styles from "./CustomerNumber.module.scss";

interface Props {
  id?: string;
  title?: string | JSX.Element;
  containerClass?: string;
  inputClass?: string;
  value: string;
  onChange: (value: string) => void;
  onValidate?: (error: string | undefined) => void;
  required?: boolean;
  placeholder?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  onBlur?: (val: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (val: React.FocusEvent<HTMLInputElement>) => void;
  newStyle?: boolean;
}

const CustomerNumber = ({
  id,
  title,
  containerClass,
  inputClass,
  value,
  onChange,
  onValidate,
  required,
  placeholder,
  fullWidth,
  disabled,
  onBlur,
  onFocus,
  newStyle = false,
}: Props) => {
  const validations = useMemo(() => {
    const validations = [(val: unknown) => isCustomerNumber(val as string)];

    if (required) {
      validations.push(hasValue);
    }
    return validations;
  }, [required]);

  const onBlurHander = (e: React.FocusEvent<HTMLInputElement>) => {
    onBlur && onBlur(e);
  };

  const onFocusHandler = (e: React.FocusEvent<HTMLInputElement>) => {
    onFocus && onFocus(e);
  };

  return (
    <div id={id} className={classNames(Styles.container, containerClass, fullWidth && Styles.fullWidth)}>
      <Input
        name={"customer_number"}
        className={inputClass}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        validate={validations}
        onValidate={(err) => onValidate && onValidate(err)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        onBlur={onBlurHander}
        onFocus={onFocusHandler}
        title={title}
        varient={newStyle ? 'new' : 'old'}
      />
    </div>
  );
};

export default CustomerNumber;
